/*
 * @Author: XiaoHuwei
 * @Date: 2020-07-17 17:57:09
 * @LastEditors: XiaoHuwei
 * @LastEditTime: 2021-07-26 15:18:23
 * @FilePath: /active/src/main.js
 */ 
import Vue from 'vue'
import App from './App.vue'
import Vant from 'vant';
import 'vant/lib/index.css';
import smoothscroll from 'smoothscroll-polyfill';
import axios from 'axios';
Vue.prototype.$axios = axios //全局注册，使用方法为:this.$axios
window.$axios = axios;
Vue.prototype.$baseUrl = 'http://apitest.txcb.com'
smoothscroll.polyfill();
Vue.use(Vant)
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
